import declare from "dojo/_base/declare";
import html from "csi/html";

const _RightMenuAccordionMixin = declare(null, {
	/**
	 * Arrange accordions given a target and expand flag
	 */
	arrangeAccordions(accordions, expand: boolean, index: number, closeOtherAccordions: boolean) {
		accordions.forEach((accordion, accordionIndex) => {
			if (index === accordionIndex) {
				this.expandAccordion(accordion, expand);
			} else if (closeOtherAccordions) {
				this.expandAccordion(accordion, false);
			}
		});
	},

	/**
	 * Expand or collapse a target accordion with a boolean.
	 */
	expandAccordion(accordion, expand: boolean): void {
		const {
			accordionExpanded,
			adHocFiltersNode,
			arrowNode,
			applyFilterCallback,
			contentNode,
			filterAttributesWidgetNode,
			searchCallback,
			textBoxNode,
			toggleFilterButtonNode,
		} = accordion;

		if (applyFilterCallback) {
			html.setVisible(adHocFiltersNode, expand);
			html.setVisible(toggleFilterButtonNode, expand);
			html.setVisible(filterAttributesWidgetNode, expand);
		}
		if (searchCallback) {
			html.setVisible(textBoxNode, expand);
		}
		// do not expand an accordion that is already expanded, and do not contract an accordion that is already contracted
		if (accordionExpanded === expand) {
			return;
		}

		const { style } = contentNode;
		if (expand) {
			html.setInnerText(arrowNode, "keyboard_arrow_up");
			style.maxHeight = `${Math.max(1300, contentNode.scrollHeight)}px`;
		} else {
			html.setInnerText(arrowNode, "keyboard_arrow_down");
			style.maxHeight = 0;
		}
		accordion.accordionExpanded = expand;
	},
});

export = _RightMenuAccordionMixin;
